import z from "zod"


const ImageExts = ["JPG", "PNG", "GIF", "BLOB"] as const
const VideoExts = ["MOV", "MP4", "WEBM"] as const

const ImageEnum = z.enum(ImageExts)
const VideoEnum = z.enum(VideoExts)

type ImageEnumType = z.infer<typeof ImageEnum>
type videoEnumType = z.infer<typeof VideoEnum>


export { ImageExts, VideoExts, ImageEnum, VideoEnum, ImageEnumType, videoEnumType }